import {Mix} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {TransformBackup} from "./TransformBackup";

export class CardTransform extends Mix(Sprite, TransformBackup) {

    constructor() {
        super();
        this.visible = false;
    }
}
